// ============================================================
// ENGINE VERSION METADATA — the single source of truth for the runtime engine
// version. Extracted from the former monolith's PlatformEngine so src/ views
// (ChangelogView, EngineView) can read the version WITHOUT reaching into the
// engine singleton. PlatformEngine.version/.versionDate/.versionName
// now read from these constants (no fork — one source). When bumping the engine
// version (HANDOVER §14), change it HERE; PlatformEngine picks it up.
// ============================================================
export const ENGINE_VERSION = '1.15.0';
export const ENGINE_VERSION_DATE = '2026-09-09';
export const ENGINE_VERSION_NAME = 'KM-sluttspill, banepad-resolver & Reporting';
